import { Injectable } from '@angular/core';

import { ClubRoles } from '../../models/clubs/club-roles.model';
import { AccountsService } from '../../services/identity/accounts.service';
import { ClubsStore } from '../clubs.store';

@Injectable({
    providedIn: 'root',
})
export class ClubPermissionService {
    constructor(private clubsStore: ClubsStore, private accountService: AccountsService) {}

    public canViewMembers(clubId: string): boolean {
        const club = this.clubsStore.member.fullClubs.find((c) => c.id === clubId || c.rooms?.some((r) => r.id === clubId));

        if (!club.communityId) return true;
        if (this.accountService.currentUser.communities.find((community) => community.id === club.communityId).hasActivateConfidentialityMode) {
            const member = club.members.find((m) => m.id === this.accountService.currentUser.userId);
            return this.accountService.isAdmin() || member?.role === ClubRoles.Admin || member?.role === ClubRoles.Animator;
        }
        return true;
    }

    public get isClubAdmin(): boolean {
        return this.clubsStore.isAdminOfDisplayedClub;
    }

    public get isRoomAnimator(): boolean {
        return this.clubsStore.isAnimatorOfDisplayedRoom && !this.clubsStore.isMainRoom;
    }
}
